import { Typography } from "@mui/material";
import { makeStyles } from "@mui/styles";
import Button from "@mui/material/Button";
import { colors } from "../../../assets/colors";
import { useContext, useEffect, useState } from "react";
import { WebrtcContext } from "../../../modules/Webrtc";

const useStyles = makeStyles(() => ({
  textWrap: {
    overflowWrap: "break-word",
    wordWrap: "break-word",
  },
}));

const LinkContainer = ({ currentWiidth }: any) => {
  const classes = useStyles();
  const [idswl, setIdswl] = useState("");
  const [copied, setCopied] = useState(false);

  const { streamActive } = useContext(WebrtcContext);

  useEffect(() => {
    const convert = async () => {
      const _idswl = await btoa(
        JSON.stringify({
          id: streamActive.remotePeer.clientid,
          name: streamActive.streamName,
        })
      );
      setIdswl(_idswl);
    };
    convert();
  }, [streamActive]);

  const handleCopy = async (text: string) => {
    const input = document.createElement("input");
    input.value = text;
    document.body.appendChild(input);

    // Select the input's content
    input.select();
    input.setSelectionRange(0, 99999); // For mobile devices

    // Copy the selected text
    document.execCommand("copy");

    // Clean up and reset the copied state
    document.body.removeChild(input);
    setCopied(true);
    return setTimeout(() => setCopied(false), 2000);
  };

  return (
    <div style={{ display: "flex", flexDirection: "column", gap: "14px" }}>
      <div
        style={{
          border: "1px solid white",
          borderRadius: 10,
          width: currentWiidth > 575 ? 210 : "100%",
          minHeight: 50,
          position: "relative",
          marginTop: 30,
          padding: 10,
        }}
      >
        <Button
          variant="contained"
          onClick={() => {
            handleCopy(`${window.location.origin}/stream/${idswl}`);
          }}
          size="small"
          sx={{
            height: "20px",
            position: "absolute",
            top: "-27px",
            right: "25px",
            translateY: "-50%",
            backgroundColor: colors.green,
            "&:hover": colors.green,
          }}
        >
          {copied ? "Copied!" : "Copy"}
        </Button>

        <div
          style={{
            overflow: "auto",
            maxHeight: 100,
          }}
        >
          <div>
            <Typography
              variant="caption"
              display="block"
              className={classes.textWrap}
            >
              {`${window.location.origin}/stream/${idswl}`}
            </Typography>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LinkContainer;
